
export default[
    {
        show(row,extra){
            return row.shbj==='1'||row.shbj==='9'
        },
        tag:'el-button',
        icon: 'el-icon-s-promotion',
        type:'text',
        text:'进入流程',
        click(row,extra){
            // this.goto({
            //     path: '/#/revision/liucheng/index',
            //     query: {
            //         id: row.by1,
            //     }
            // });
            var pathname = window.location.pathname
            window.top.$tagFrame.pushTag({
                src:`${pathname}`+'?t='+Math.random()+`#/revision/liucheng/index?id=`+row.by1+'&ext3='+row.ext3,
                title:row.zbproname,
                type: 'href',
                id:row.by1,
            })

        }
    },{
        show(row,extra){
            return row.shbj!=='1'&&row.shbj!=='9'
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/ZbProject/del.json`,{
                id:row.zbprocode,
                oper:'del'
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
        }
    },{
        show(row,extra){
            return row.shbj!=='1'&&row.shbj!=='9'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            var pathname = window.location.pathname
         
            if(row.ext3){
                window.top.$tagFrame.pushTag({
                    src:`${pathname}`+'?t='+Math.random()+`#/bidding/project/zfcg/form?zbprocode=`+row.zbprocode+'&type='+row.ext3+'&t='+Math.random(),
                    title:'修改'+row.zbproname,
                    type: 'href',
                    topparent:'common-tag',
                })
                // this.goto({
                //     path: '/bidding/project/zfcg/form',
                //     query: {
                //         zbprocode: row.zbprocode,
                //         type:row.ext3
                //     }
                // });
            }else{
                window.top.$tagFrame.pushTag({
                    src:`/Zbdl/ZbProject/edit?id=`+row.zbprocode+'&newType=edit'+'&t='+Math.random(),
                    title:'修改'+row.zbproname,
                    type: 'href',
                    topparent:'common-tag',
                })
                // this.gotoFrame({
                //     title:'修改招标项目',
                //     url:'/Zbdl/ZbProject/edit',
                //     id: row.zbprocode,
                // })
            }
        }
    },
]